<div class="modal inmodal fade in parcel-modal parcel-history-modal" [ngClass]="{'show': showModal}">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="hideModal()">
                    <span>×</span><span class="sr-only">Close</span>
                </button>
                <h4 class="modal-title">History of Pass On Log: {{data.passOnLogNumber}}</h4>
            </div>
            <div class="modal-body">
                <div class="timeline">
                    <spinner [spinnerShow]="loadingHistory"></spinner>
                    <ul class="timeline__list" *ngIf="!loadingHistory">
                        <li *ngFor="let a of activities">
                            <section *ngIf="a.action !== 'ignore'">
                                <header class="timeline__header">
                                    <span>
                                        <time>{{ a.loggedAt | date:'dd.MM.yyyy hh:mm a' }}</time> by {{ a.userFullName }}
                                    </span>
                                </header>

                                <main class="timeline__content">
                                    <div [ngSwitch]="a.action">

                                        <ng-template [ngSwitchCase]="'update'">
                                            {{ a.activityType }}
                                            <span class="timeline__active">"{{a.name}}"</span>
                                            <ul class="field-changes">
                                                <li *ngFor="let item of a.data">
                                                    {{ item?.key }} :
                                                    <span class="timeline__active">"{{ item?.old }}"</span>
                                                    changed to
                                                    <span class="timeline__active">"{{ item?.new }}"</span>
                                                </li>
                                            </ul>
                                        </ng-template>

                                        <ng-template [ngSwitchCase]="'create'">
                                            <p>
                                                {{ a.activityType }}
                                                <span class="timeline__active">"{{a.name}}"</span>
                                                was received
                                            </p>

                                            <ul class="field-changes">
                                                <li *ngFor="let item of a.data">
                                                    {{ item.key }} :
                                                    <span class="timeline__active">{{ item.value }}</span>
                                                </li>
                                            </ul>
                                        </ng-template>
                                    </div>
                                </main>
                            </section>
                        </li>
                    </ul>
                    <div *ngIf="!loadingHistory && activities.length < 1" class="text-center">
                        No history is available for this pass
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/pass-on-log/pass-on-log-history/pass-on-log-history.component.html